<div class="loyalty-sign-up-container">
  <!-- Mandatory Fields Message -->
  @if (mandatoryTextMsg()) {
    <div class="mandatory-msg mb-3" [innerHTML]="mandatoryTextMsg()"></div>
  }

  <!-- Form -->
  <form [formGroup]="registerFormGroup">
    <!-- Personal Information Section -->
    <div class="section-header pb-4">
      <h3 class="section-title mb-0 font-weight-semibold fs-5">{{ localeObj().tf_4_Checkout_guestDetails_personalInfo }}</h3>
    </div>

    <div
      class="sign-up-form-fields-wrap"
      [ngClass]="{
        'd-flex flex-wrap form-field-two-column': formLayout() === 'two-column',
      }"
    >
      @for (field of registerFormFields; track field.fieldName) {
        @if (field.fieldName === 'password') {
          <div class="w-100"></div>
        }

        <div
          class="form-field-row mb-4"
          [ngClass]="{
            'has-error': isRegisterFormSubmitted() && getErrorMsg(field, registerFormGroup.controls[field.fieldName]),
            'password-field': field.type === 'password' || field.fieldName === 'confirmPassword',
            'pt-5': field.fieldName === 'confirmPassword' && !isMobile() && context() === 'sign-up-page',
            'form-field-two-column-width': formLayout() === 'two-column' && field.type !== 'checkbox',
            'w-100': field.type === 'checkbox',
          }"
        >
          <!-- Text, Email, Address Fields -->
          @if (field.type === 'text' || field.type === 'email') {
            @if (!field.isDropdown) {
              <app-textbox
                [id]="field.fieldName"
                [label]="field.name"
                [type]="field.type"
                [bindValue]="registerFormGroup.get(field.fieldName)?.value"
                [required]="field.compulsory"
                [autocomplete]="field.autoCompleteType"
                [customClass]="'signup-textbox-no-padding'"
                (onChange)="registerFormGroup.get(field.fieldName)?.setValue($event)"
                [error]="
                  isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.errors?.required
                    ? localeObj().tf_4_Checkout_preferences_requiredField
                    : isRegisterFormSubmitted() &&
                        field.invalidErrMsg &&
                        registerFormGroup.controls[field.fieldName]?.invalid
                      ? field.invalidErrMsg
                      : ''
                "
              />
            }

            <!-- Dropdown (Gender, State without explicit states) -->
            @if (field.isDropdown && !field.data?.length && field.fieldName !== 'country') {
              <app-textbox
                [id]="field.fieldName"
                [label]="field.name"
                [type]="field.type"
                [bindValue]="registerFormGroup.get(field.fieldName)?.value"
                [required]="field.compulsory"
                [autocomplete]="field.autoCompleteType"
                [customClass]="'signup-textbox-no-padding'"
                (onChange)="registerFormGroup.get(field.fieldName)?.setValue($event)"
                [error]="
                  isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.errors?.required
                    ? localeObj().tf_4_Checkout_preferences_requiredField
                    : isRegisterFormSubmitted() &&
                        field.invalidErrMsg &&
                        registerFormGroup.controls[field.fieldName]?.invalid
                      ? field.invalidErrMsg
                      : ''
                "
              />
            }

            <!-- Dropdown (Gender, Country, State with data) -->
            @if (field.isDropdown && (field.data?.length || field.fieldName === 'country')) {
              <div class="form-group neutral-white-color-bg">
                <app-form-dropdown
                  [id]="field.fieldName"
                  [list]="transformToDropdownFormat(field.fieldName === 'country' ? preparedCountryList() : field.data)"
                  [btnLabel]="field.name + (field.compulsory ? ' *' : '')"
                  [bindValue]="registerFormGroup.get(field.fieldName)?.value"
                  (selectionChange)="
                    registerFormGroup.get(field.fieldName)?.setValue($event);
                    field.fieldName === 'country' && onCountryChange()
                  "
                />
                @if (isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.invalid) {
                  <small class="danger-color d-block mt-1">
                    {{ field.invalidErrMsg || localeObj().tf_4_Checkout_preferences_requiredField }}
                  </small>
                }
              </div>
            }
          }

          <!-- Date of Birth Field -->
          @if (field.type === 'date') {
            <div class="form-group">
              <div class="input-group date-input-group">
                <input
                  [id]="field.fieldName"
                  class="form-control"
                  [placeholder]="isUsBasedFormat() ? 'MM/DD/YYYY' : 'DD/MM/YYYY'"
                  [formControlName]="field.fieldName"
                  [attr.autocomplete]="field.autoCompleteType"
                  ngbDatepicker
                  #d="ngbDatepicker"
                  [minDate]="field.minDate"
                  [maxDate]="field.maxDate"
                  maxlength="10"
                />
                <button
                  class="btn btn-icon calendar-btn"
                  (click)="d.toggle()"
                  type="button"
                  attr.aria-label="{{ localeObj().tf_1_Calendar_Loyalty_openCalendar }}"
                >
                  <i class="fa-light fa-calendar-days"></i>
                </button>
              </div>
              @if (isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.invalid) {
                <small class="danger-color d-block mt-1">
                  {{ field.invalidErrMsg || localeObj().tf_4_Checkout_preferences_requiredField }}
                </small>
              }
            </div>
          }

          <!-- Phone Number Fields -->
          @if (field.type === 'phone' || field.type === 'cell-phone' || field.type === 'business-phone') {
            <div class="form-group phone-field-wrapper d-flex gap-2 w-100">
              <div class="country-code-selector">
                <ngx-intl-tel-input
                  appPhoneInputAccessibility
                  [selectedCountryISO]="selectedCountryISO()"
                  [separateDialCode]="true"
                  [formControl]="
                    field.type === 'phone'
                      ? phoneFormControl
                      : field.type === 'business-phone'
                        ? businessPhoneFormControl
                        : cellPhoneFormControl
                  "
                >
                </ngx-intl-tel-input>
              </div>
              <div class="phone-number-input w-100">
                <app-textbox
                  [id]="field.fieldName"
                  [label]="field.name"
                  type="tel"
                  [bindValue]="registerFormGroup.get(field.fieldName)?.value"
                  [required]="field.compulsory"
                  [maxlength]="15"
                  [customClass]="'signup-textbox-no-padding'"
                  (onChange)="registerFormGroup.get(field.fieldName)?.setValue($event)"
                  [error]="
                    isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.errors?.required
                      ? field.invalidErrMsg || localeObj().tf_4_Checkout_preferences_requiredField
                      : ''
                  "
                />
              </div>
            </div>
          }

          <!-- Security Section (before password fields) -->
          @if (field.fieldName === 'password') {
            <div class="section-header pb-4 d-flex justify-content-between align-items-center">
              <h3
                class="section-title mb-0 font-weight-semibold large-font-size"
                [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signUp_security"
              ></h3>

              <app-tooltip
                [tooltipDisplay]="localeObj().tf_1_Calendar_Loyalty_signUp_requirements"
                tooltipPosition="bottom"
                background="light"
                [customLinkClass]="'custom-border-bottom small-font-size'"
                [customContentClass]="
                  context() === 'side-panel' || isMobile()
                    ? 'start-auto end-0 transform-none mobile-side-panel-tooltip'
                    : ''
                "
                (onFocusEvent)="tooltipTop.show()"
              >
                <div class="password-guide-tooltip base-font-size">
                  <h6
                    class="custom-border-bottom pb-3 mb-3"
                    [innerHTML]="localeObj().tf_5_Loyalty_signup_password_requirement_heading"
                  ></h6>
                  <p class="mb-1" [innerHTML]="localeObj().tf_5_Loyalty_signup_password_length"></p>
                  <ul class="mb-0 ps-3 list-styled">
                    @for (ptype of passwordType; track $index) {
                      <li>{{ ptype.passwordType }}</li>
                    }
                  </ul>
                </div>
              </app-tooltip>
            </div>
          }

          <!-- Password Fields -->
          @if (field.type === 'password') {
            <div class="password-field-wrapper position-relative">
              <app-textbox
                [id]="field.fieldName"
                [label]="field.name"
                [type]="showPasswordMap[field.fieldName] ? 'text' : 'password'"
                [bindValue]="registerFormGroup.get(field.fieldName)?.value"
                [required]="field.compulsory"
                [autocomplete]="field.autoCompleteType"
                [customClass]="'signup-textbox-no-padding'"
                (onChange)="registerFormGroup.get(field.fieldName)?.setValue($event)"
                [error]="
                  isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.errors?.required
                    ? localeObj().tf_4_Checkout_preferences_requiredField
                    : isRegisterFormSubmitted() &&
                        field.mismatchErrMsg &&
                        registerFormGroup.controls[field.fieldName]?.errors?.mismatch
                      ? field.mismatchErrMsg
                      : isRegisterFormSubmitted() &&
                          field.minLengthErrMsg &&
                          registerFormGroup.controls[field.fieldName]?.errors?.minlength
                        ? field.minLengthErrMsg
                        : isRegisterFormSubmitted() &&
                            field.maxLengthErrMsg &&
                            registerFormGroup.controls[field.fieldName]?.errors?.maxlength
                          ? field.maxLengthErrMsg
                          : isRegisterFormSubmitted() &&
                              field.patternErrMsg &&
                              registerFormGroup.controls[field.fieldName]?.errors?.pattern
                            ? field.patternErrMsg
                            : ''
                "
              />
              <app-button
                variant="link"
                iconDisplay="icon-only"
                [icon]="showPasswordMap[field.fieldName] ? 'fa-light fa-eye-slash' : 'fa-light fa-eye'"
                [ariaLabel]="
                  showPasswordMap[field.fieldName]
                    ? localeObj().tf_1_Calendar_Loyalty_hidePassword
                    : localeObj().tf_1_Calendar_Loyalty_showPassword
                "
                [label]="''"
                customClass="password-toggle-icon"
                (onClickEvent)="togglePasswordVisibility(field.fieldName)"
              />
            </div>
          }

          <!-- Checkbox Fields (Terms & Privacy) -->
          @if (field.type === 'checkbox') {
            <div class="checkbox-field-wrapper">
              <app-checkbox
                [cname]="field.fieldName"
                [data]="getCheckboxData(field)"
                [customClass]="'signup-checkbox-compact'"
                (selectionChanged)="handleCheckboxChange($event, field.fieldName)"
              />
              <div class="checkbox-label-with-link lh-sm">
                <span [innerHTML]="field.label"></span>
                <a class="text-decoration-underline" [href]="field.url" target="_blank" rel="noopener noreferrer">{{
                  field.urlLabel
                }}</a>
              </div>
            </div>
            @if (isRegisterFormSubmitted() && registerFormGroup.controls[field.fieldName]?.errors?.['required']) {
              <small class="danger-color">
                {{ field.requiredErrMsg }}
              </small>
            }
          }
        </div>
      }
    </div>
  </form>

  <div
    class="submit-sign-in-button-wrap pt-3"
    [ngClass]="{
      'pb-50': formLayout() !== 'two-column',
      'd-flex flex-wrap form-field-two-column align-items-center': formLayout() === 'two-column',
    }"
  >
    <!-- Submit Button -->
    <div
      class="submit-btn-wrapper"
      [ngClass]="{
        'form-field-two-column-width': formLayout() === 'two-column',
      }"
    >
      <app-button
        variant="primary"
        fullWidth
        [label]="localeObj().tf_1_Calendar_Loyalty_btn_register"
        [isDisabled]="isRegisterButtonLoading()"
        [isLoading]="isRegisterButtonLoading()"
        (onClickEvent)="handleSignUpSubmit()"
      />
    </div>

    <!-- Sign In Link -->
    <div
      class="sign-in-link-wrapper"
      [ngClass]="{
        'mt-32 text-center': formLayout() !== 'two-column' || isMobile(),
        'form-field-two-column-width': formLayout() === 'two-column',
        'text-end': formLayout() === 'two-column' && !isMobile(),
      }"
    >
      <span class="me-2 small-font-size" [innerHTML]="localeObj().tf_1_Calendar_Loyalty_signUp_alreadyHaveAnAccount"></span>
      <app-button
        variant="link"
        [label]="localeObj().tf_1_Calendar_Loyalty_signUp_signInNow"
        (onClickEvent)="handleSignInSidePanel()"
        [isDisabled]="isRegisterButtonLoading()"
      />
    </div>
  </div>
</div>
